import TextField from 'components/forms/textField/TextField';
import PropertyFormFieldLabel from 'pages/property/common/PropertyFormFieldLabel';
import { Trans, useTranslation } from 'react-i18next';
import { TransLink } from 'components/text/TransLink';

const BathroomsField = () => {
  const { t } = useTranslation();

  return (
    <TextField
      label={
        <PropertyFormFieldLabel name="capacityDetails.bathroomCount">
          {t('pageProperty.mainSettings.capacityDetails.bathroomCount')}
        </PropertyFormFieldLabel>
      }
      name="capacityDetails.bathroomCount"
      colSmInput={7}
      colSmLabel={5}
      rightTooltip={
        <Trans
          i18nKey="pageProperty.mainSettings.capacityDetails.bathroomCountTooltip"
          components={{
            link1: (
              <TransLink
                target="_blank"
                data-testid="request-documentation"
                href="https://help.hostfully.com/en/articles/2564270-set-rooms-and-bed-types-for-your-property#h_c311b715b8"
                rel="noreferrer"
              />
            ),
          }}
        />
      }
      disabled
    />
  );
};

export default BathroomsField;
